export default __webpack_public_path__ + "static/media/activeM2.99de1436.svg";